import reducer from './reducers'

import * as featureFlagsOperations from './actions'
import * as featureFlagsTypes from './types'
import * as featureFlagsSelectors from './selectors'
import useFeatureFlag from './hooks'

export {
  featureFlagsOperations,
  featureFlagsTypes,
  featureFlagsSelectors,
  useFeatureFlag,
}

export default reducer
